import {
  CHECK_ACCESS,
  CHECK_ACCESS_SUCCESS,
  CHECK_ACCESS_ERROR,
  ACCESS_DENIED,
  DISMISS_MESSAGE,
  SAVE_URLS_PARAMS,
  SAVE_PATIENT_DETAILS,
  SAVE_CONSULT_NOTE_VISIBILITY,
  UPDATE_EBS_NUMBER,
  SET_REDO_ERX_LIST,
  IS_PATIENT_ONLINE,
  SAVE_APPOINTMENT_ID,
  SET_IS_PBS_AUTHORITY_REQUIRED,
  SET_IS_RE_AUTHENTICATION_REQUIRED,
  SET_PRESCRIBING_MESSAGE
} from "../constants/auth";

export const checkUserAccess = data => ({
  type: CHECK_ACCESS,
  payload: data
});

export const checkUserAccessSuccess = data => ({
  type: CHECK_ACCESS_SUCCESS,
  payload: data
});

export const checkUserAccessError = data => ({
  type: CHECK_ACCESS_ERROR,
  payload: data
});

export const saveUrlParams = data => ({
  type: SAVE_URLS_PARAMS,
  payload: data
});

export const savePatientDetails = data => ({
  type: SAVE_PATIENT_DETAILS,
  payload: data
});

export const userAccessDenied = () => ({
  type: ACCESS_DENIED
});

export const saveConsultNoteVisibility = data => ({
  type: SAVE_CONSULT_NOTE_VISIBILITY,
  payload: data
});

export const dismissMessage = () => ({
  type: DISMISS_MESSAGE
});

export const updateEbsNumber = data => ({
  type: UPDATE_EBS_NUMBER,
  payload: data
});

export const setRedoErxList = data => ({
  type: SET_REDO_ERX_LIST,
  payload: data
});
export const isPatientOnline = data => ({
  type: IS_PATIENT_ONLINE,
  payload: data
});

export const saveAppointmentId = data => ({
  type: SAVE_APPOINTMENT_ID,
  payload: data
});

export const setIsPBSAuthorityRequired = data => ({
  type: SET_IS_PBS_AUTHORITY_REQUIRED,
  payload: data
});

export const setIsReAuthenticationRequired = data => ({
  type: SET_IS_RE_AUTHENTICATION_REQUIRED,
  payload: data
});

export const setPrescribingMessage = data => ({
  type: SET_PRESCRIBING_MESSAGE,
  payload: data
});
